import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit, OnDestroy {

  public loading = true;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy(): void {
  }

  loadData(): void {
    const that = this;
    that.loading = true;
    that.loading = false;
  }

  public goTo(url): void {
    this.router.navigate([url]);
  }
}
